import React, { useState, useEffect, createContext } from 'react'
import { useIntl } from 'react-intl'
import PageTitle from '../../components/Typography/PageTitle'
import { CardBody } from '@windmill/react-ui'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { removeEmptyFields } from '../../lib/helpers/formatters'
import { KTCard } from '../../../_metronic/helpers'
import { CanaliTable } from '../Agenzia/CanaliCategorie/table/CanaliTable'
import { KTSVG } from '../../../_metronic/helpers'

export const canWriteContext = createContext(null)

function CanaliCategorie({ currentPermissions }: any) {
  const { handleSubmit, register, reset } = useForm()
  const [filters, setFilters] = useState({})
  const intl = useIntl()
  const canWrite = currentPermissions.can('write', 'salesChannels')

  function onSetFilters(filters: any) {
    setFilters(removeEmptyFields(filters))
  }

  function onClearFilters() {
    reset()
    setFilters({})
  }

  useEffect(() => {
    document.title = 'Control Room - Canali Categoria'
  }, [])

  return (
    <>
      <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
        <div className="flex items-center justify-between">
          <PageTitle>{intl.formatMessage({ id: 'CHANNELS.TITLE' })}</PageTitle>
          <div
            className="d-flex justify-content-end"
            data-kt-user-table-toolbar="base">
            {canWrite && (
              <Link to="/agenzia/canali-vendita/nuovo-canale">
                <button type="button" className="btn btn-primary">
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-2"
                  />
                  {intl.formatMessage({ id: 'COMMON.NEW' })}
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
      <KTCard className="mb-8 hidden">
        <CardBody>
          <p
            className="mb-4 font-semibold text-gray-500 text-lg"
            style={{ fontSize: '1.125rem', fontWeight: '600' }}>
            {intl.formatMessage({ id: 'COMMON.FILTERS' })}
          </p>
          <form onSubmit={handleSubmit(onSetFilters)}>
            <div
              className="grid gap-2 grid-cols-1 items-end"
              style={{
                display: 'flex',
                width: '100%',
                alignItems: 'flex-end'
              }}>
              <label>
                <span>{intl.formatMessage({ id: 'COMMON.CODE' })}</span>
                <input
                  className="form-control form-control-lg mt-1"
                  {...register('code')}
                />
              </label>
              <div className="flex mt-5">
                <button type="submit" className="btn btn-primary fw-bold px-6">
                  {intl.formatMessage({ id: 'COMMON.FILTER' })}
                </button>
              </div>
              <div className="flex mt-5">
                <button
                  className="btn btn-light btn-active-light-primary fw-bold me-2 px-6"
                  onClick={onClearFilters}>
                  {intl.formatMessage({ id: 'COMMON.CLEAR_FILTER' })}
                </button>
              </div>
            </div>
          </form>
        </CardBody>
      </KTCard>
      <KTCard className="mb-8">
        <canWriteContext.Provider value={canWrite}>
          <CanaliTable filters={filters} />
        </canWriteContext.Provider>
      </KTCard>
    </>
  )
}

export default CanaliCategorie
